export const pdfDocumentOptions = {
	disableFontFace: true,
} as const;
